import React from 'react'
import PdfViewer from '../../../main/second/mainbar/seller/Components/Transportation/PdfViewer'

interface Props {
    file: Blob
    handleSharePdf: () => void
    handleDownloadPdf: () => void
    handleClearFile: () => void
    handleOpenPdf: () => void
}

const PdfPreview: React.FC<Props> = (props) => <PdfViewer {...props} />

export default PdfPreview
